import { IntercomContext } from './Intercom.context';
import useIntercom from 'src/hooks/Intercom/Intercom.hook';
import { tIntercomProviderProps } from 'src/hooks/Intercom/Intercom.types';
import { VITE_INTERCOM_APP_ID } from 'src/constants/envs';

/**
 * @module providers/IntercomProvider
 * Provider component that wraps the application with Intercom context.
 *
 * @description This provider initializes Intercom and makes its functionality
 * available to all child components through the IntercomContext.
 *
 * @param {tIntercomProviderProps} props - Provider props including children and configuration
 * @returns {JSX.Element} Provider component wrapping children
 *
 * @example
 * // Wrap your app with IntercomProvider
 * <IntercomProvider autoInitialize={true}>
 *   <App />
 * </IntercomProvider>
 */
export default function IntercomProvider(props: tIntercomProviderProps) {
  const { children, autoInitialize = true } = props;
  const appId = VITE_INTERCOM_APP_ID;
  const intercom = useIntercom(appId, autoInitialize);

  return (
    <IntercomContext.Provider value={intercom}>
      {children}
    </IntercomContext.Provider>
  );
}
